import produce from 'immer'

function storeGeoObjectId(draft, geoObject) {
  if (!draft[geoObject.category]) { return }
  draft[geoObject.category].objectIds.push(geoObject.id)
}

function removeGeoObjectId(draft, categoryId, geoObjectId) {
  if (!draft[categoryId]) { return }
  draft[categoryId].objectIds = draft[categoryId].objectIds.filter(oid => oid !== geoObjectId)
}

export default (state = {}, action) => produce(state, draft => {
  switch (action.type) {
  case 'INIT_DASHBOARD_SUCCESS':
    action.categories.forEach(category => {
      draft[category.id] = category
    })
    return
  case 'CREATE_GEO_CATEGORY_SUCCESS':
  case 'LOAD_GEO_CATEGORY_SUCCESS':
  case 'UPDATE_GEO_CATEGORY_SUCCESS':
    draft[action.category.id] = {
      ...(draft[action.category.id] ? draft[action.category.id] : {}),
      ...action.category,
    }
    return
  case 'DELETE_GEO_CATEGORY_SUCCESS':
    delete draft[action.categoryId]
    return
  case 'CREATE_GEO_OBJECT_SUCCESS':
  case 'LOAD_GEO_OBJECT_SUCCESS':
    storeGeoObjectId(draft, action.geoObject)
    return
  case 'DELETE_GEO_OBJECT_SUCCESS':
    removeGeoObjectId(draft, action.geoCategoryId, action.geoObjectId)
    return
  }
})